import { motion } from 'framer-motion';
import { GiCheckMark } from 'react-icons/gi';
import { loginFormVariants } from '../../../constants/animationVariants';
import { AppointmentSlot } from '../../../types/appointments';
import { showTimeIn12HrsFormat } from '../../../utils/timeAndDate';

interface IModalTimeSlot {
  id: string;
  index: number;
  name: string;
  slot: AppointmentSlot;
  isDisabled: boolean;
  onSelect: (index: number, slotDuration: string) => void;
  isSlotSelected: (index: number) => boolean;
}

const ModalTimeSlot = ({
  id,
  index,
  name,
  slot,
  isDisabled,
  onSelect,
  isSlotSelected,
}: IModalTimeSlot) => {
  // destructuring the slot object here
  const { start_time, end_time } = slot || {};

  const slotDuration = `${showTimeIn12HrsFormat(
    start_time
  )} - ${showTimeIn12HrsFormat(end_time)}`;

  // rendering modal time slot component here
  return (
    <label
      title={
        isDisabled ? 'You must select time slots sequentially!' : undefined
      }
      htmlFor={id}
      className={`grid grid-cols-[50px_2fr] [&>div:not(:last-child)]:border-r-2 bg-base-light-gray py-3 rounded-md shadow-academia-sm text-center [&>div:not(:last-child)]:border-legal-brown duration-300 ${
        isDisabled
          ? 'opacity-50 cursor-not-allowed'
          : 'cursor-pointer active:scale-95 hover:opacity-70'
      }`}
    >
      <div className='flex items-center justify-center'>
        <input
          type='checkbox'
          id={id}
          className='hidden'
          name={name}
          value={slotDuration}
          onChange={(e) => onSelect && onSelect(index, e.target.value)}
          disabled={isDisabled}
        />

        <div
          className={`flex items-center justify-center size-5 rounded-md border-2 duration-300 ${
            isSlotSelected
              ? isSlotSelected(index)
                ? 'bg-legal-dark-blue border-legal-dark-blue'
                : 'bg-transparent border-legal-dark-blue'
              : 'bg-transparent border-legal-dark-blue'
          }`}
        >
          <motion.div
            variants={loginFormVariants}
            initial='hidden'
            animate={
              isSlotSelected
                ? isSlotSelected(index)
                  ? 'visible'
                  : 'hidden'
                : 'hidden'
            }
          >
            <GiCheckMark className='size-3 text-legal-brown' />
          </motion.div>
        </div>
      </div>

      <div>
        <p className='font-semibold text-base-dark-blue'>{slotDuration}</p>
      </div>
    </label>
  );
};

export default ModalTimeSlot;
